import { useGqlQuery } from '@API/useAvQuery';
import { QueryKey } from '@fabric-ui/utils';
import { gql } from 'graphql-request';

export const GET_USERS_INFO = gql`
  query findUsersMetadata($userIds: [String]) {
    findUsersMetadata(userIds: $userIds) {
      id
      firstName
      lastName
      email
      currentAccountRoleId
    }
  }
`;

const emptyRes = { '-1': 'Zscaler' };

export const useGetUsersInfo = (
  userIds,
  select = data =>
    data?.reduce(
      (obj, { id, firstName, lastName }) => ({
        ...obj,
        [id]: `${firstName} ${lastName}`,
      }),
      emptyRes
    ),
  defaultRes: object = emptyRes
) => {
  const {
    data: usersInfo = defaultRes,
    refetch,
    isLoading,
    isPending,
  } = useGqlQuery({
    queryKey: [QueryKey.UsersInfo, ...userIds, select.toString()],
    query: GET_USERS_INFO,
    variables: { userIds },
    select,
    enabled: !!userIds.length,
    gcTime: 0,
  });
  return { usersInfo, refetch, isLoading, isPending };
};
